import { useEffect, useRef, useState, type ReactNode } from 'react';
import { plans as fetchPlans, usd, type Interval, type PlanOption } from '../../api';
import { Link } from '../../router';
import { PZ13 } from './fx';
import { PROBLEM_ART } from './ProblemArt';
// The cmx.sh landing sections (the 1.3″ design language, Figma node 35:2), static markup. Behaviour lives in fx.ts, styles in landing.css.

export function Sprites() {
  return (
<><svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
  <defs>
    <symbol id="caret" viewBox="0 0 4.104 3.42"><path fill="currentColor" d="M1.368 0.228V0H2.736V0.228H1.368ZM1.368 0.684V0.456H2.736V0.684H1.368ZM2.28 1.14V0.912H3.192V1.14H2.28ZM0.912 1.14V0.912H1.824V1.14H0.912ZM0.912 1.596V1.368H1.824V1.596H0.912ZM2.28 1.596V1.368H3.192V1.596H2.28ZM0.456 2.052V1.824H1.368V2.052H0.456ZM2.736 2.052V1.824H3.648V2.052H2.736ZM2.736 2.508V2.28H3.648V2.508H2.736ZM0.456 2.508V2.28H1.368V2.508H0.456ZM3.192 2.964V2.736H4.104V2.964H3.192ZM0 2.964V2.736H0.912V2.964H0ZM0 3.42V3.192H0.912V3.42H0ZM3.192 3.42V3.192H4.104V3.42H3.192Z" /></symbol>
    <symbol id="carets" viewBox="0 0 24.1665 3.42"><use href="#caret" x="0" /><use href="#caret" x="5.0156" /><use href="#caret" x="10.0312" /><use href="#caret" x="15.0469" /><use href="#caret" x="20.0625" /></symbol>
    <symbol id="star" viewBox="0 0 5.472 5.472"><path fill="currentColor" d="M0.608 5.472V4.256H1.216V3.648H1.824V3.04H0V2.432H1.824V1.824H1.216V1.216H0.608V0H1.824V1.216H2.432V1.824H3.04V1.216H3.648V0H4.864V1.216H4.256V1.824H3.648V2.432H5.472V3.04H3.648V3.648H4.256V4.256H4.864V5.472H3.648V4.256H3.04V3.648H2.432V4.256H1.824V5.472H0.608Z" /></symbol>
    <symbol id="stars" viewBox="0 0 32.222 5.472"><use href="#star" x="0" /><use href="#star" x="6.6875" /><use href="#star" x="13.375" /><use href="#star" x="20.0625" /><use href="#star" x="26.75" /></symbol>
    <symbol id="lamps" viewBox="0 0 22 4"><rect x="12" y="1" width="10" height="2" fill="currentColor" /><circle cx="2" cy="2" r="2" fill="currentColor" /><circle cx="8" cy="2" r="2" fill="currentColor" /></symbol>
    <symbol id="chipface" viewBox="0 0 84 84">
      <rect x=".5" y=".5" width="83" height="83" rx="6" fill="url(#chipg)" stroke="rgba(11,11,12,.16)" />
      <path fill="#0B0B0C" fillOpacity=".86" fillRule="evenodd" d="M70.291 68.5415C70.291 69.508 69.5075 70.2915 68.541 70.2915H16.041C15.0745 70.2915 14.291 69.508 14.291 68.5415V16.0415C14.291 15.075 15.0745 14.2915 16.041 14.2915H68.541C69.5075 14.2915 70.291 15.075 70.291 16.0415V68.5415ZM19.3819 43.087C19.3819 44.0535 20.1654 44.837 21.1319 44.837H37.9956C38.9621 44.837 39.7456 45.6205 39.7456 46.587V63.4506C39.7456 64.4171 40.5291 65.2006 41.4956 65.2006H48.1774C49.1439 65.2006 49.9274 64.4171 49.9274 63.4506V36.4051C49.9274 35.4386 49.1439 34.6551 48.1774 34.6551H21.1319C20.1654 34.6551 19.3819 35.4386 19.3819 36.4051V43.087ZM19.3819 27.8142C19.3819 28.7807 20.1654 29.5642 21.1319 29.5642H53.2683C54.2348 29.5642 55.0183 30.3477 55.0183 31.3142V63.4506C55.0183 64.4171 55.8018 65.2006 56.7683 65.2006H63.4501C64.4166 65.2006 65.2001 64.4171 65.2001 63.4506V21.1324C65.2001 20.1659 64.4166 19.3824 63.4501 19.3824H21.1319C20.1654 19.3824 19.3819 20.1659 19.3819 21.1324V27.8142ZM19.3819 63.4506C19.3819 64.4171 20.1654 65.2006 21.1319 65.2006H32.9047C33.8712 65.2006 34.6547 64.4171 34.6547 63.4506V51.6779C34.6547 50.7114 33.8711 49.9279 32.9047 49.9279H21.1319C20.1654 49.9279 19.3819 50.7114 19.3819 51.6779V63.4506Z" />
    </symbol>
    <radialGradient id="chipg" cx="50%" cy="38%" r="70%"><stop offset="0" stopColor="#FFFFFF" /><stop offset="1" stopColor="#EDEDF2" /></radialGradient>
  </defs>
</svg>
<svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false"><defs><symbol id="g-claude" viewBox="0 0 7 7"><path fill="currentColor" d="M3 0h1v1h-1zM1 1h1v1h-1zM3 1h1v1h-1zM5 1h1v1h-1zM2 2h3v1h-3zM0 3h7v1h-7zM2 4h3v1h-3zM1 5h1v1h-1zM3 5h1v1h-1zM5 5h1v1h-1zM3 6h1v1h-1z" /></symbol><symbol id="g-codex" viewBox="0 0 7 7"><path fill="currentColor" d="M2 0h3v1h-3zM1 1h1v1h-1zM5 1h1v1h-1zM0 2h1v1h-1zM6 2h1v1h-1zM0 3h1v1h-1zM6 3h1v1h-1zM0 4h1v1h-1zM6 4h1v1h-1zM1 5h1v1h-1zM5 5h1v1h-1zM2 6h3v1h-3z" /></symbol><symbol id="g-opencode" viewBox="0 0 7 7"><path fill="currentColor" d="M1 0h2v1h-2zM4 0h2v1h-2zM1 1h1v1h-1zM5 1h1v1h-1zM1 2h1v1h-1zM5 2h1v1h-1zM0 3h1v1h-1zM6 3h1v1h-1zM1 4h1v1h-1zM5 4h1v1h-1zM1 5h1v1h-1zM5 5h1v1h-1zM1 6h2v1h-2zM4 6h2v1h-2z" /></symbol><symbol id="g-gemini" viewBox="0 0 7 7"><path fill="currentColor" d="M3 0h1v1h-1zM3 1h1v1h-1zM2 2h3v1h-3zM0 3h7v1h-7zM2 4h3v1h-3zM3 5h1v1h-1zM3 6h1v1h-1z" /></symbol><symbol id="g-copilot" viewBox="0 0 7 7"><path fill="currentColor" d="M2 0h3v1h-3zM1 1h1v1h-1zM5 1h1v1h-1zM0 2h1v1h-1zM6 2h1v1h-1zM0 3h1v1h-1zM3 3h1v1h-1zM6 3h1v1h-1zM0 4h1v1h-1zM6 4h1v1h-1zM1 5h1v1h-1zM5 5h1v1h-1zM2 6h3v1h-3z" /></symbol><symbol id="g-amp" viewBox="0 0 7 7"><path fill="currentColor" d="M1 2h2v1h-2zM0 3h1v1h-1zM3 3h1v1h-1zM6 3h1v1h-1zM4 4h2v1h-2z" /></symbol><symbol id="g-pi" viewBox="0 0 7 7"><path fill="currentColor" d="M0 1h7v1h-7zM1 2h1v1h-1zM5 2h1v1h-1zM1 3h1v1h-1zM5 3h1v1h-1zM1 4h1v1h-1zM5 4h1v1h-1zM1 5h1v1h-1zM5 5h1v1h-1zM1 6h1v1h-1zM5 6h2v1h-2z" /></symbol><symbol id="g-play" viewBox="0 0 4 7"><path fill="currentColor" d="M0 0h1v1h-1zM0 1h2v1h-2zM0 2h3v1h-3zM0 3h4v1h-4zM0 4h3v1h-3zM0 5h2v1h-2zM0 6h1v1h-1z" /></symbol><symbol id="g-moon" viewBox="0 0 12 12"><path fill="currentColor" d="M5 0h2v1h-2zM3 1h2v1h-2zM2 2h3v1h-3zM1 3h3v1h-3zM1 4h3v1h-3zM0 5h4v1h-4zM0 6h4v1h-4zM1 7h4v1h-4zM1 8h4v1h-4zM2 9h5v1h-5zM3 10h6v1h-6zM5 11h2v1h-2z" /></symbol><symbol id="g-bolt" viewBox="0 0 7 7"><path fill="currentColor" d="M4 0h2v1h-2zM3 1h2v1h-2zM2 2h2v1h-2zM1 3h5v1h-5zM3 4h2v1h-2zM2 5h2v1h-2zM1 6h2v1h-2z" /></symbol><symbol id="g-term" viewBox="0 0 7 7"><path fill="currentColor" d="M0 0h7v1h-7zM0 1h1v1h-1zM6 1h1v1h-1zM0 2h1v1h-1zM2 2h1v1h-1zM6 2h1v1h-1zM0 3h1v1h-1zM3 3h1v1h-1zM6 3h1v1h-1zM0 4h1v1h-1zM2 4h1v1h-1zM4 4h3v1h-3zM0 5h1v1h-1zM6 5h1v1h-1zM0 6h7v1h-7z" /></symbol><symbol id="g-check" viewBox="0 0 7 7"><path fill="currentColor" d="M6 1h1v1h-1zM5 2h1v1h-1zM0 3h1v1h-1zM4 3h1v1h-1zM1 4h1v1h-1zM3 4h1v1h-1zM2 5h1v1h-1z" /></symbol><symbol id="g-bang" viewBox="0 0 7 7"><path fill="currentColor" d="M3 0h1v1h-1zM3 1h1v1h-1zM3 2h1v1h-1zM3 3h1v1h-1zM3 5h1v1h-1z" /></symbol><symbol id="g-spark" viewBox="0 0 5 5"><path fill="currentColor" d="M2 0h1v1h-1zM2 1h1v1h-1zM0 2h5v1h-5zM2 3h1v1h-1zM2 4h1v1h-1z" /></symbol><symbol id="g-dot3" viewBox="0 0 5 1"><path fill="currentColor" d="M0 0h1v1h-1zM2 0h1v1h-1zM4 0h1v1h-1z" /></symbol></defs></svg>
</>
  );
}

/* the figures' small parts: a glyph from the sprite, a panel's head and foot, a section kicker, the frame's corner marks */
const G = ({ id, w = 14 }: { id: string; w?: number }) => (
  <svg className="gl" width={w} height="14" aria-hidden="true">
    <use href={`#g-${id}`} />
  </svg>
);
const Ok = () => (
  <svg className="gl ok" width="14" height="14" aria-hidden="true">
    <use href="#g-check" />
  </svg>
);
const Head = ({ children }: { children: ReactNode }) => (
  <div className="p-head">
    <svg className="carets" width="30" height="5" aria-hidden="true">
      <use href="#carets" />
    </svg>
    {children}
    <svg className="carets" width="30" height="5" aria-hidden="true">
      <use href="#carets" />
    </svg>
  </div>
);
const Foot = ({ children }: { children?: ReactNode }) => (
  <div className="p-foot">
    {children ?? (
      <svg className="stars deco" width="32" height="6" aria-hidden="true">
        <use href="#stars" />
      </svg>
    )}
    <span className="deco bars" />
  </div>
);
const Status = ({ dot = '', children }: { dot?: string; children: ReactNode }) => (
  <span className="ink">
    <span className={`dot ${dot}`} />
    {children}
  </span>
);
const Kicker = ({ children }: { children: string }) => (
  <p className="kicker">
    <span data-dc="">// {children}</span>{' '}
    <svg className="carets" width="36" height="5" aria-hidden="true">
      <use href="#carets" />
    </svg>
  </p>
);
const Marks = ({ flush }: { flush?: boolean }) => (
  <>
    <span className="mk mk-l" style={flush ? { left: '-4px' } : undefined} aria-hidden="true" />
    <span className="mk mk-r" style={flush ? { right: '-4px' } : undefined} aria-hidden="true" />
  </>
);
const Rings = () => (
  <span className="t-rings">
    <i />
    <i />
    <i />
  </span>
);
/** A cell of a figure grid: its drawing on top, then the words. */
function Cell({ fig, loop, n, title, children }: { fig: ReactNode; loop?: string; n?: string; title: string; children: ReactNode }) {
  return (
    <article className="cell" data-loop={loop}>
      {fig}
      {n && (
        <span className="fnum" aria-hidden="true">
          // {n}
        </span>
      )}
      <h3 className="h3">{title}</h3>
      <p>{children}</p>
    </article>
  );
}
const Stage = ({ mark, raw, children, className = '' }: { mark: string; raw?: boolean; children: ReactNode; className?: string }) => (
  <div className={`stage ${className}`} aria-hidden="true">
    <span className={raw ? 'st-mark tl raw' : 'st-mark tl'}>{mark}</span>
    {children}
  </div>
);

// the pixel icons under the hero
const MOON = 'M5 0H7V1H5V0ZM3 1H5V2H3V1ZM2 2H5V3H2V2ZM1 3H4V4H1V3ZM1 4H4V5H1V4ZM0 5H4V6H0V5ZM0 6H4V7H0V6ZM1 7H5V8H1V7ZM1 8H5V9H1V8ZM2 9H7V10H2V9ZM3 10H9V11H3V10ZM5 11H7V12H5V11Z';
const BOLT = 'M8 0H12V2H8V0ZM6 2H10V4H6V2ZM4 4H8V6H4V4ZM2 6H12V8H2V6ZM6 8H10V10H6V8ZM4 10H8V12H4V10ZM2 12H6V14H2V12Z';
const TERM = 'M0 0H14V2H0V0ZM0 2H2V4H0V2ZM12 2H14V4H12V2ZM0 4H2V6H0V4ZM4 4H6V6H4V4ZM12 4H14V6H12V4ZM0 6H2V8H0V6ZM6 6H8V8H6V6ZM12 6H14V8H12V6ZM0 8H2V10H0V8ZM4 8H6V10H4V8ZM0 10H2V12H0V10ZM12 10H14V12H12V10ZM0 12H14V14H0V12ZM10 8V10H8V8H10ZM14 8V10H12V8H14Z';
const Mini = ({ d, s, title, children }: { d: string; s: number; title: string; children: string }) => (
  <li className="mini">
    <span className="ic" aria-hidden="true">
      <svg className="gl" width={s} height={s} viewBox={`0 0 ${s} ${s}`} aria-hidden="true">
        <path d={d} fill="currentColor" />
      </svg>
    </span>
    <h3 className="h3">{title}</h3>
    <p>{children}</p>
  </li>
);

export function Band() {
  return (
    <div className="minis-row">
      <Marks />
      <div className="plate-flush">
        <ul className="minis">
          <Mini d={BOLT} s={14} title="Powerful">
            Up to 16 cores and 64 GB.
          </Mini>
          <Mini d={MOON} s={12} title="Always on">
            Close the lid. Everything keeps running.
          </Mini>
          <Mini d={TERM} s={14} title="Feels local">
            Instant terminal. Full desktop.
          </Mini>
        </ul>
      </div>
    </div>
  );
}

/* The problem: the statement, then four failures drawn in two halves, laptop left (it sleeps and maxes out) and VPS right (it lags and
   has no screen), each a label, an isometric drawing between dashed rules, a title and one line. Then the answer. */
const LAPTOP_ICON = 'M2 2h10v1h-10zM2 3h1v6h-1zM11 3h1v6h-1zM2 9h10v1h-10zM0 11h14v1h-14z';
const VPS_ICON = 'M1 1h12v1h-12zM1 2h1v3h-1zM12 2h1v3h-1zM3 3h1v1h-1zM7 3h4v1h-4zM1 5h12v1h-12zM1 8h12v1h-12zM1 9h1v3h-1zM12 9h1v3h-1zM3 10h1v1h-1zM7 10h4v1h-4zM1 12h12v1h-12z';
/* the two halves, each with its own heading: the laptop left, the VPS right */
const HALVES: [string, string, string][] = [
  ['Option 1 · Your laptop', LAPTOP_ICON, 'Your laptop sleeps and runs out of memory.'],
  ['Option 2 · A VPS', VPS_ICON, 'A VPS stays on, but it’s expensive and painful to work on.'],
];
const FAILURES: [keyof typeof PROBLEM_ART, string, string, string, ReactNode][] = [
  ['sleeps', LAPTOP_ICON, 'Your laptop', 'Sleeps', 'Close the lid and every agent stops.'],
  ['maxed', LAPTOP_ICON, 'Your laptop', 'Maxed out', <>Run more than a few agents and it runs out of memory: 15.6 of 16&nbsp;GB, at 98°.</>],
  ['laggy', VPS_ICON, 'A VPS', 'Laggy', <>A VPS stays on, but typing lags over SSH, +180&nbsp;ms per key, and agent CLIs glitch.</>],
  ['headless', VPS_ICON, 'A VPS', 'Headless', 'Copy-paste and images break, localhost won’t open, and there’s no GUI.'],
];
export function Problem() {
  return (
    <section className="sec" id="problem" aria-labelledby="problem-title">
      <div className="plate sec-head pr-head">
        <div>
          <Kicker>The problem</Kicker>
          <h2 className="h2" id="problem-title">
            <span className="ln">Agents and dev work need to run 24/7.</span> <span className="ln">Your laptop can’t.</span>
          </h2>
        </div>
        <p className="lead">You run several agents in parallel, plus builds, type checks, tests and dev servers. That needs a computer that’s always on, with plenty of CPU and memory.</p>
      </div>
      <div className="plate-flush">
        <Marks flush />
        <ul className="pr-row">
          {HALVES.map(([label, icon, heading], g) => (
            <li className="pr-grp" key={label}>
              <p className="pr-gk">
                <svg className="pr-ic" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
                  <path d={icon} fill="currentColor" />
                </svg>
                // {label}
              </p>
              <h3 className="pr-gt">{heading}</h3>
              <div className="pr-stage">
                {FAILURES.slice(g * 2, g * 2 + 2).map(([art], i) => (
                  <div className="pr-art" key={art}>
                    <span className="pr-n" aria-hidden="true">
                      <i>[</i>0{g * 2 + i + 1}<i>]</i>
                    </span>
                    {PROBLEM_ART[art]}
                  </div>
                ))}
              </div>
              <ul className="pr-pair">
                {FAILURES.slice(g * 2, g * 2 + 2).map(([art, , , title, line]) => (
                  <li className="pr-card" key={art}>
                    <h4 className="pr-t">{title}</h4>
                    <p className="pr-b">{line}</p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
      <div className="plate">
        <div className="pr-ans">
          <p className="pr-lb">// The answer</p>
          <p className="pr-turn">
            <b>cmx gives you both:</b> a powerful cloud computer that’s <em>always on</em>, and <em>feels like your laptop</em>.
          </p>
          <a className="pr-go" href="#cmx">
            See how it works
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M6 2v8M2.5 6.5 6 10l3.5-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

const Tick = () => (
  <svg className="ck" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M3 7.5L5.8 10.2L11 4.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
/* the three frames of FIG. 04: art (file, class, width, height), the status chip, the caption, then the points it pays off */
const LID: { art: [string, string, number, number][]; st: string; on: boolean; mid?: boolean; n: string; t: string; s: string; pts: string[] }[] = [
  { art: [['lid-open', 'ob-l', 475, 483]], st: '4 agents running', on: true, n: '01', t: 'Start your agents', s: 'From your laptop, like you always do.', pts: ['Set up like your laptop, in one click', 'An instant terminal'] },
  {
    art: [['lid-closed', 'ob-s', 445, 277], ['cmx-box', 'ob-c', 276, 256]],
    st: '4 still running',
    on: true,
    mid: true,
    n: '02',
    t: 'Close the lid',
    s: 'They keep running on cmx, all night.',
    pts: ['Always on, 24/7', 'Up to 16 cores and 64 GB, all in parallel', 'Agents, Docker and Chrome preinstalled'],
  },
  { art: [['lid-done', 'ob-l', 475, 483]], st: '4 done · PR ready', on: false, n: '03', t: 'Open it, pick up', s: 'Everything is right where you left it.', pts: ['A full desktop, like a second monitor', 'Clipboard, files and localhost just work'] },
];

/* cmx: close the lid, in three frames (start on your laptop, it keeps running on cmx, pick up where you left off) */
export function Both() {
  return (
    <section className="sec" id="cmx" aria-labelledby="cmx-title">
      <Marks />
      <div className="plate sec-head">
        <Kicker>cmx</Kicker>
        <h2 className="h2 h2-wide" id="cmx-title">
          cmx runs your agents and dev work in the cloud, and feels like your laptop.
        </h2>
        <p className="lead">Your own Linux machine in the cloud, always on, with room for everything you run in parallel: agents, builds, type checks, tests and dev servers. And it works like the computer in front of you.</p>
      </div>
      <div className="plate plate-fig">
        <figure className="stage s7" aria-label="Start your agents, close the lid, open it and pick up">
          <span className="st-mark tl" aria-hidden="true">
            FIG. 04 · CLOSE THE LID
          </span>
          <ol className="rail">
            {LID.map((f) => (
              <li className={`fr${f.mid ? ' mid' : ''}`} key={f.n}>
                <div className="art">
                  {f.art.map(([src, cls, w, h]) => (
                    <img className={`ob ${cls}`} src={`/landing/${src}.svg`} width={w} height={h} alt="" key={src} />
                  ))}
                  <span className={`st${f.on ? ' on' : ''}`}>
                    {f.on ? <i /> : <Tick />}
                    {f.st}
                  </span>
                </div>
                <p className="cap">
                  <span className="n">{f.n}</span>
                  <b>{f.t}</b>
                  <span>{f.s}</span>
                </p>
                <ul className="pts">
                  {f.pts.map((t) => (
                    <li key={t}>
                      <Tick />
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ol>
        </figure>
      </div>
    </section>
  );
}

/* The cloud computer: powerful, always on, reachable, ready */
export function Cloud() {
  return (
    <section className="sec" id="cloud" aria-labelledby="cloud-title">
      <Marks />
      <div className="plate sec-head">
        <Kicker>Cloud computer</Kicker>
        <h2 className="h2" id="cloud-title">
          <span className="ln">A powerful computer</span> <span className="ln">that’s always on.</span>
        </h2>
        <p className="lead">Run all your agents and dev work in parallel, around the clock, without slowing down your laptop.</p>
      </div>
      <div className="plate-flush">
        <Marks flush />
        <div className="fgrid">
          <Cell
            loop="up"
            n="01"
            title="Always on"
            fig={
              <Stage mark="FIG. 05">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Uptime</Head>
                  <ul className="p-list">
                    <li className="on">
                      <span className="dot" />
                      <span>uptime · last 30 days</span>
                      <b className="nums" style={{ fontWeight: 500 }}>
                        100%
                      </b>
                    </li>
                  </ul>
                  <div className="days" id="days" />
                  <Foot />
                </div>
              </Stage>
            }
          >
            Close your laptop. Agents, builds and dev servers keep running.
          </Cell>
          <Cell
            loop="chip"
            n="02"
            title="Up to 16 cores and 64 GB"
            fig={
              <div className="stage power" aria-hidden="true">
                <span className="st-mark tl">FIG. 06</span>
                <span className="st-mark tr">CMX-YOU</span>
                <div className="chipw chip-tilt">
                  <div className="chip" id="chip">
                    <img src="/landing/chip80.svg" width="80" height="80" alt="" />
                  </div>
                  <span className="chip-pins" />
                </div>
                <div className="meters">
                  <div className="meter">
                    <div className="row">
                      <span>cpu · 16 vCPU</span>
                      <b className="nums">94%</b>
                    </div>
                    <div className="cells" data-cells="16" data-on="15" />
                  </div>
                  <div className="meter">
                    <div className="row">
                      <span>memory · 64 GB</span>
                      <b className="nums">41.2 GB</b>
                    </div>
                    <div className="cells" data-cells="16" data-on="10" />
                  </div>
                </div>
              </div>
            }
          >
            Run agents, builds, type checks, tests and dev servers at the same time.
          </Cell>
          <Cell
            loop="cool"
            n="03"
            title="Your laptop stays free"
            fig={
              <Stage mark="FIG. 07">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>This Mac</Head>
                  <div className="meters pad">
                    <div className="meter">
                      <div className="row">
                        <span>cpu</span>
                        <b className="nums">6%</b>
                      </div>
                      <div className="cells" data-cells="16" data-on="1" />
                    </div>
                    <div className="meter">
                      <div className="row">
                        <span>memory</span>
                        <b className="nums">3.1 GB</b>
                      </div>
                      <div className="cells" data-cells="16" data-on="3" />
                    </div>
                  </div>
                  <Foot>
                    <Status>cool and quiet</Status>
                  </Foot>
                </div>
              </Stage>
            }
          >
            The heavy work runs in the cloud, so your laptop stays fast, cool and on battery.
          </Cell>
          <Cell
            n="04"
            title="Reach it from anywhere"
            fig={
              <Stage mark="FIG. 08">
                <div className="panel pcol" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Keep working</Head>
                  <div className="kw">
                    <span className="kt">
                      <i style={{ width: '32px' }} />
                      Mac app
                    </span>
                    <span className="kt">
                      <i style={{ width: '65px' }} />
                      Browser
                    </span>
                    <span className="kt">
                      <i style={{ width: '24px' }} />
                      Phone
                    </span>
                    <span className="ping">
                      <span className="am">
                        <i />
                      </span>
                      Agent needs you<span className="n">now</span>
                    </span>
                  </div>
                  <Foot />
                </div>
              </Stage>
            }
          >
            Open the same machine from the Mac app, any browser or your iPhone.
          </Cell>
          <Cell
            loop="restart"
            n="05"
            title="Sessions survive restarts"
            fig={
              <Stage mark="FIG. 09">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>After a restart</Head>
                  <ul className="p-list">
                    <li>
                      <Ok />
                      <span>Fix the upload test</span>
                      <span className="v">resumed</span>
                    </li>
                    <li>
                      <Ok />
                      <span>Payments API retries</span>
                      <span className="v">resumed</span>
                    </li>
                    <li>
                      <Ok />
                      <span>pnpm dev</span>
                      <span className="v nums">:3000</span>
                    </li>
                  </ul>
                  <Foot />
                </div>
              </Stage>
            }
          >
            After a restart, each agent comes back to the conversation it was in.
          </Cell>
          <Cell
            loop="pre"
            n="06"
            title="Ready to work"
            fig={
              <Stage mark="FIG. 10">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Preinstalled</Head>
                  <ul className="p-list">
                    <li>
                      <G id="claude" />
                      <span>Claude Code</span>
                      <span className="v">claude</span>
                    </li>
                    <li>
                      <G id="codex" />
                      <span>Codex</span>
                      <span className="v">codex</span>
                    </li>
                    <li>
                      <G id="gemini" />
                      <span>Gemini CLI and more</span>
                      <span className="v">gemini</span>
                    </li>
                    <li>
                      <G id="term" />
                      <span>Docker and Chrome</span>
                      <span className="v">ready</span>
                    </li>
                  </ul>
                  <Foot />
                </div>
              </Stage>
            }
          >
            Claude Code, Codex and more, with Docker and Chrome, preinstalled and kept up to date.
          </Cell>
        </div>
      </div>
    </section>
  );
}

/* Your work, multiplied: two hour meters, your laptop's stopped at 0008 when the lid closed and cmx's rolled on to 0384
   (16 at once × 24 h), with 48× on the seam between them. Under each, a work log: what ran and for how long */
const WORK = ['claude · auth', 'codex · payments', 'claude · tests', 'pnpm build', 'tsc --watch', 'dev · web', 'dev · api', 'dev · admin',
  'gemini · search', 'playwright e2e', 'claude · docs', 'codex · migrate', 'docker compose', 'pytest', 'claude · review', 'cursor · ui'];
// a wheel's strip: 9, then 0–9 twice, then 9; --i is the index that rests in the window (a larger index rolls further)
const STRIP = ['9', ...'01234567890123456789', '9'];
const Wheel = ({ i, zero }: { i: number; zero?: boolean }) => (
  <span className={zero ? 'hm-wh z' : 'hm-wh'}>
    <span className="hm-win">
      <span className="hm-st" style={{ ['--i' as string]: i }}>
        {STRIP.map((d, k) => (
          <span key={k}>{d}</span>
        ))}
      </span>
    </span>
  </span>
);
const Meter = ({ cmx, label, status, wheels, log, foot, aria }: {
  cmx?: boolean; label: string; status: ReactNode; wheels: [number, boolean?][]; log: [string, string, boolean?][]; foot: ReactNode; aria: string;
}) => (
  <div className={cmx ? 'hm-mt hm-cmx' : 'hm-mt'} role="img" aria-label={aria}>
    <div className="hm-h" aria-hidden="true">
      <span className="hm-l">{label}</span>
      <span className="hm-s">
        <i className="hm-lmp" />
        {status}
      </span>
    </div>
    <div className="hm-b" aria-hidden="true">
      <div className="hm-whs">
        {wheels.map(([i, z], k) => (
          <Wheel key={k} i={i} zero={z} />
        ))}
      </div>
      <p className="hm-u">Hours of work today</p>
    </div>
    <div className="hm-log" aria-hidden="true">
      <div className="hm-lh">
        <span>Item</span>
        <span>Hours</span>
      </div>
      <div className="hm-lv">
        <ul className="hm-lr">
          {log.map(([n, h, off]) => (
            <li key={n} className={off ? 'off' : undefined}>
              <span>{n}</span>
              <i />
              <span className="hm-hr">{h}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="hm-f" aria-hidden="true">
      {foot}
    </div>
  </div>
);

export function Multiply() {
  return (
    <section className="sec" id="multiply" aria-labelledby="multiply-title">
      <Marks />
      <div className="plate sec-head">
        <Kicker>Your work, multiplied</Kicker>
        <h2 className="h2" id="multiply-title">
          Get far more done every day.
        </h2>
        <p className="lead">cmx runs your agents and dev work in parallel and never stops, so work keeps moving while you review, sleep or travel.</p>
      </div>
      <div className="plate-flush">
        <Marks flush />
        <figure className="stage hm-stage">
          <span className="st-mark tl" aria-hidden="true">
            FIG. 19
          </span>
          <div className="hm">
            <Meter
              label="// Your laptop"
              status="Stopped at 17:00"
              wheels={[[1, true], [1, true], [1, true], [9]]}
              log={[['you + 1 task', '8 h'], ['lid closed', '0 h', true]]}
              foot={<span>1 at a time <i>×</i> 8 h</span>}
              aria="Your laptop: 8 hours of work today, one thing at a time for 8 hours."
            />
            <div className="hm-mul" aria-hidden="true">
              <b>48×</b>
              <span>Same day</span>
            </div>
            <Meter
              cmx
              label="// cmx · Standard XL"
              status={
                <>
                  Running<span className="hm-sx"> · 16 at once</span>
                </>
              }
              wheels={[[1, true], [4], [19], [15]]}
              log={WORK.map((w) => [w, '24 h'] as [string, string])}
              foot={<span>16 at once <i>×</i> 24 h</span>}
              aria="cmx Standard XL: 384 hours of work today, 16 things at once for 24 hours."
            />
          </div>
        </figure>
      </div>
      <div className="plate">
        <p className="hm-fine">Up to 48× on Standard XL (16 cores, 32 GB), running 24 hours a day.</p>
      </div>
    </section>
  );
}

/* Feels local: everything that's slow or broken over SSH, working the way it does on a laptop */
export function Local() {
  return (
    <section className="sec" id="local" aria-labelledby="local-title">
      <Marks />
      <div className="plate sec-head">
        <Kicker>Feels local</Kicker>
        <h2 className="h2" id="local-title">
          It feels like your laptop.
        </h2>
        <p className="lead">Everything that’s slow or broken over SSH works the way it does on your laptop.</p>
      </div>
      <div className="plate-flush">
        <Marks flush />
        <div className="fgrid">
          <Cell
            n="01"
            title="Instant terminal"
            fig={
              <Stage mark="FIG. 11">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Terminal</Head>
                  <div className="tbody">
                    <div>
                      <span className="d">~/webapp</span> $ claude --continue
                    </div>
                    <div>
                      &gt; fix the flaky upload test<span className="cursor" />
                    </div>
                  </div>
                  <div className="p-read">
                    <span>each keystroke</span>
                    <b className="nums">&lt; 10 ms</b>
                  </div>
                  <Foot />
                </div>
              </Stage>
            }
          >
            Typing feels exactly like on your laptop, so Claude Code and Codex feel just as fast. Under 10 ms per keystroke.
          </Cell>
          <Cell
            loop="dt"
            n="02"
            title="Full desktop, like a second monitor"
            fig={
              <Stage mark="FIG. 12">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Desktop</Head>
                  <div className="dt" id="dt">
                    <div className="dt-win">
                      <div className="dt-app">
                        <span className="dt-row" style={{ top: '20px', width: '58%' }} />
                        <span className="dt-row" style={{ top: '31px', width: '72%' }} />
                        <span className="dt-row" style={{ top: '42px', width: '44%' }} />
                        <span className="dt-btn" />
                      </div>
                      <span className="dock">
                        <i />
                        <i />
                        <i />
                        <i />
                      </span>
                      <span className="dt-ptr">
                        <span className="dt-ring" />
                        <svg width="13" height="18" viewBox="0 0 13 18">
                          <path d="M1 1v14l3.6-3.4 2.6 5.6 2.4-1.1-2.6-5.5H12z" fill="#1C1917" stroke="#fff" strokeWidth="1" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </div>
                    <div className="dt-read">
                      <span>
                        <span className="dot dt-dot" />
                        your mouse and keyboard
                      </span>
                      <svg className="stars deco" width="32" height="6">
                        <use href="#stars" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Stage>
            }
          >
            Stream the machine’s desktop to your laptop and control it with your own mouse and keyboard. Run a browser or any app.
          </Cell>
          <Cell
            loop="clip"
            n="03"
            title="Shared clipboard"
            fig={
              <Stage mark="FIG. 13">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Clipboard</Head>
                  <ul className="p-list">
                    <li>
                      <Ok />
                      <span>Copied on this Mac</span>
                      <span className="v">⌘C</span>
                    </li>
                    <li>
                      <Ok />
                      <span>Pasted on cmx-you</span>
                      <span className="v">⌘V</span>
                    </li>
                  </ul>
                  <div className="p-read clip">
                    <span>“Bearer eyJhbGciOi…”</span>
                  </div>
                  <Foot />
                </div>
              </Stage>
            }
          >
            Copy on your Mac, paste on the machine, and back.
          </Cell>
          <Cell
            loop="drop"
            n="04"
            title="Drag and drop files"
            fig={
              <Stage mark="FIG. 14">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Terminal</Head>
                  <div className="tbody">
                    <div>&gt; why does this layout break?</div>
                    <div>
                      <span className="drop">[Image #1] screenshot.png</span>
                    </div>
                  </div>
                  <div className="p-read">
                    <span className="ok">
                      <Ok />
                      dropped from Finder
                    </span>
                    <b className="nums">1.2 MB</b>
                  </div>
                  <Foot />
                </div>
              </Stage>
            }
          >
            Drag an image or a file onto the terminal and your agent has it.
          </Cell>
          <Cell
            loop="loc"
            n="05"
            title="localhost on your Mac"
            fig={
              <Stage mark="FIG. 15" raw>
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Terminal</Head>
                  <div className="tbody">
                    <div>
                      <span className="d">~/webapp</span> $ <span className="ty">pnpm dev</span>
                    </div>
                    <div>
                      → Local: <span className="d">http://localhost:3000</span>
                    </div>
                  </div>
                  <div className="p-read">
                    <span className="ok">
                      <Ok />
                      opened on this Mac
                    </span>
                    <b className="nums">:3000</b>
                  </div>
                  <Foot />
                </div>
              </Stage>
            }
          >
            The dev server your agent starts opens at localhost on your Mac.
          </Cell>
          <Cell
            loop="auth"
            n="06"
            title="Links open on your Mac"
            fig={
              <Stage mark="FIG. 16">
                <div className="panel" style={{ ['--pw' as string]: '280px' }}>
                  <Head>Sign in</Head>
                  <div className="tbody">
                    <div>
                      <span className="d">~</span> $ <span className="ty">gh auth login</span>
                    </div>
                    <div>! Open github.com/login/device</div>
                  </div>
                  <div className="p-read">
                    <span className="ok">
                      <Ok />
                      opened in your browser
                    </span>
                    <b>this Mac</b>
                  </div>
                  <Foot />
                </div>
              </Stage>
            }
          >
            Sign-in links and previews open in your own browser.
          </Cell>
        </div>
      </div>
      <div className="plate plate-cell">
        <p className="fine">Latency is added on top of your network round trip; it depends on where you are.</p>
      </div>
    </section>
  );
}

/* Magic Setup: the old copy dialog. A page arcs from ~/code on this Mac to ~/code on cmx-you while the bar fills and the
   project being moved ticks by at the same path (fx.ts), then what else moves, summed up underneath */
const HAIR = { vectorEffect: 'non-scaling-stroke' } as const;
// a folder in the scene's line language: the back with pages peeking out, then the front flap that opens (cmx-you takes the pale blue)
function Folder({ to, who, children }: { to?: boolean; who: string; children: ReactNode }) {
  return (
    <div className={to ? 'fd to' : 'fd'}>
      <div className="fdi">
        <svg className="fb" viewBox="0 0 88 72" aria-hidden="true">
          <path d="M6 12.5h22l5 5h49a2 2 0 0 1 2 2V66H4V14.5a2 2 0 0 1 2-2z" className="fbk" strokeWidth="1" {...HAIR} />
          <g className="sh">
            <path d="M14 30V20.5h44l6 6V30" fill="#fff" strokeWidth="1" {...HAIR} />
            <path d="M58 20.5v6h6" fill="none" strokeWidth="1" {...HAIR} />
            <path d="M20 25.5h28" strokeWidth="1" {...HAIR} />
            <path d="M26 19V15h40v15" fill="#fff" strokeWidth="1" {...HAIR} />
            <path d="M31 19.5h22" strokeWidth="1" {...HAIR} />
          </g>
        </svg>
        <svg className="ff" viewBox="0 0 88 72" aria-hidden="true">
          <path d="M4 66h80v3H4z" className="fsl" strokeWidth="1" {...HAIR} />
          <path d="M4 25.5a2 2 0 0 1 2-2h76a2 2 0 0 1 2 2V66H4z" className="fdf" strokeWidth="1" {...HAIR} />
          <path d="M8 27.5h72" className="fhl" strokeWidth="1" {...HAIR} />
          {children}
        </svg>
      </div>
      <b>{who}</b>
      <span>~/code</span>
    </div>
  );
}
const ALSO: [string, string, string][] = [
  ['M7 1.5v11M1.5 7h11M3.1 3.1l7.8 7.8M10.9 3.1l-7.8 7.8', 'Claude Code, 4 MCP servers, Codex', 'agents'],
  ['M2.5 4.5L5.5 7l-3 2.5M7.5 10h4', 'zsh, oh-my-zsh and dotfiles', 'shell'],
  ['M5 2.5C3.5 2.5 3.5 3.5 3.5 4.5S3.5 6.5 2 7c1.5.5 1.5 1.5 1.5 2.5s0 2 1.5 2M9 2.5c1.5 0 1.5 1 1.5 2S10.5 6.5 12 7c-1.5.5-1.5 1.5-1.5 2.5s0 2-1.5 2', 'Node, Python, Go', 'languages'],
  ['M6.8 7.3L12 2.1M10 4.1l1.6 1.6', 'GitHub, Vercel, Google Cloud', 'sign-ins'],
];
export function Setup() {
  return (
    <section className="sec" id="setup" aria-labelledby="setup-title">
      <div className="plate cp-w">
        <div className="cp-h">
          <Kicker>Magic Setup</Kicker>
          <h2 className="h2" id="setup-title">
            <span className="ln">Set up like your laptop,</span> <span className="ln">in one click.</span>
          </h2>
          <p className="lead">Magic Setup finds your projects, agents, tools and sign-ins, and sets up your cloud machine just like your laptop. Every project lands at the same path.</p>
        </div>
      </div>
      <div className="plate">
        <figure className="stage cp-stage">
          <span className="st-mark tl" aria-hidden="true">FIG. 17</span>
          <div className="panel cp" role="group" aria-label="Moving in: copying from This Mac to cmx-you">
            <Head>Moving in</Head>
            <div className="appbar" aria-hidden="true">
              <Rings />
              <span className="at">This Mac to cmx-you</span>
              <Rings />
            </div>
            <div className="cp-body">
              <div className="fly" aria-hidden="true">
                <Folder who="This Mac">
                  <rect x="35" y="37" width="18" height="12" rx="1.5" fill="#fff" stroke="#78716C" strokeWidth="1" {...HAIR} />
                  <path d="M31.5 52.5h25" stroke="#78716C" strokeWidth="1" strokeLinecap="round" {...HAIR} />
                </Folder>
                <div className="trk">
                  <i className="pg-x">
                    <i className="pg-y">
                      <svg width="22" height="28" viewBox="0 0 22 28">
                        <path d="M1.5 1.5h13l6 6v19h-19z" fill="#fff" stroke="#78716C" />
                        <path d="M14.5 1.5v6h6" fill="none" stroke="#78716C" />
                        <path d="M5 12h12M5 16h12M5 20h8" stroke="#A8A29E" />
                      </svg>
                    </i>
                  </i>
                </div>
                <Folder to who="cmx-you">
                  <rect x="33" y="37" width="22" height="6.5" rx="1.5" fill="#fff" stroke="#1570EF" strokeWidth="1" {...HAIR} />
                  <rect x="33" y="46" width="22" height="6.5" rx="1.5" fill="#fff" stroke="#1570EF" strokeWidth="1" {...HAIR} />
                  <circle cx="36.8" cy="40.25" r="1" fill="#1570EF" />
                  <circle cx="36.8" cy="49.25" r="1" fill="#1570EF" />
                </Folder>
              </div>
              <p className="cp-t">Moving 15 projects (2.4 GB)</p>
              <p className="cp-p">
                Now copying <code className="cur">~/code/ui</code>
                <span className="sp">
                  {' '}
                  to <code className="b cur">~/code/ui</code> on cmx-you, the same path
                </span>
                .
              </p>
              <div className="cpbar" role="progressbar" aria-label="Projects moved" aria-valuemin={0} aria-valuemax={15} aria-valuenow={9}>
                {Array.from({ length: 15 }, (_, k) => (
                  <i key={k} className={k < 9 ? 'on' : undefined} />
                ))}
              </div>
              <p className="cp-n">
                <span>
                  <b className="nums cnt">9</b> of 15 projects
                </span>
                <span>then agents, shell, languages and sign-ins</span>
              </p>
            </div>
            <Foot>
              <Status>same paths as your Mac</Status>
            </Foot>
          </div>
        </figure>
        <div className="cp-sum">
          <div className="tot">
            <b className="nums">15</b>
            <span>projects, 2.4 GB. Nothing leaves your Mac until Move In, and you pick what moves.</span>
          </div>
          <ul className="also">
            {ALSO.map(([d, what, kind]) => (
              <li key={kind}>
                <svg className="gl" width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  {kind === 'sign-ins' && <circle cx="4.8" cy="9.2" r="2.7" />}
                  <path d={d} />
                </svg>
                <span>{what}</span>
                <span className="v">{kind}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

/* On your phone: four screens of the app on one hairline row (the lab's "Four screens"), each phone cropped at the same
   dashed rule, then what it does. The screens are illustrative mock content */
const PhGl = ({ id, color }: { id: string; color?: string }) => (
  <svg className="gl" width="12" height="12" aria-hidden="true" style={color ? { color } : undefined}>
    <use href={`#g-${id}`} />
  </svg>
);
const PhBar = ({ time }: { time: string }) => (
  <div className="ph-sb">
    <span>{time}</span>
    <i className="ph-isl" />
    <i className="ph-bat" />
  </div>
);
function PhCard({ tag, n, title, children, screen }: { tag: string; n: string; title: string; children: string; screen: ReactNode }) {
  return (
    <li className="cd">
      <p className="cd-tag">
        <span>{tag}</span>
        <span className="cd-n">
          <i>[</i>
          {n}
          <i>]</i>
        </span>
      </p>
      <div className="cd-art">
        <div className="cd-ph">
          <div className="ph" aria-hidden="true">
            <div className="ph-s">
              {screen}
              <i className="ph-home" />
            </div>
          </div>
        </div>
      </div>
      <h3 className="cd-t">{title}</h3>
      <p className="cd-b">{children}</p>
    </li>
  );
}
export function Phone() {
  return (
    <section className="sec phs" id="iphone" aria-labelledby="phone-title">
      <div className="plate sec-head">
        <div>
          <Kicker>On your phone</Kicker>
          <h2 className="h2" id="phone-title">
            <span className="ln">Your whole cloud computer,</span> <span className="ln">on your phone.</span>
          </h2>
        </div>
        <div>
          <p className="lead">The iPhone app controls everything on your cloud computer: your agents, your dev work, the terminal and the full desktop. No laptop needed. When an agent needs you, you get a notification and can answer right there.</p>
        </div>
      </div>
      <div className="plate-flush">
        <ul className="cd-row">
          <PhCard
            tag="Home"
            n="01"
            title="Agents"
            screen={
              <>
                <PhBar time="9:41" />
                <div className="ph-ttl">
                  <b>cmx-you</b>
                  <span>Agents</span>
                </div>
                <p className="ph-k">Needs you</p>
                <div className="ph-ask">
                  <PhGl id="codex" />
                  <b>Payments</b>
                  <span className="ph-st">
                    <i className="sd sd-am" />
                    needs you
                  </span>
                  <span className="m">Run the migration on staging?</span>
                </div>
                <p className="ph-k">Running</p>
                <ul className="ph-ls">
                  <li>
                    <PhGl id="claude" color="#D97757" />
                    <span>Upload test</span>
                    <span className="ph-st">
                      <i className="sd sd-ok" />
                      running
                    </span>
                  </li>
                  <li>
                    <PhGl id="term" />
                    <span>pnpm dev</span>
                    <span className="ph-st">:3000</span>
                  </li>
                </ul>
              </>
            }
          >
            Every agent on your cloud computer, what it is doing, and which one needs you.
          </PhCard>
          <PhCard
            tag="Terminal"
            n="02"
            title="Terminal"
            screen={
              <>
                <PhBar time="9:41" />
                <div className="ph-ttl">
                  <b>Terminal</b>
                  <span>~/code/payments</span>
                </div>
                <div className="ph-term">
                  <p>
                    <i>$</i> git pull
                  </p>
                  <p className="mu">Already up to date.</p>
                  <p>
                    <i>$</i> pnpm dev
                  </p>
                  <p className="ok">ready on localhost:3000</p>
                  <p>
                    <i>$</i> pnpm test
                  </p>
                  <p className="mu">48 passed</p>
                  <p>
                    <i>$</i> <b className="cur" />
                  </p>
                </div>
                <div className="ph-keys">
                  {['esc', 'tab', 'ctrl', '↑', '↓'].map((k) => (
                    <span key={k}>{k}</span>
                  ))}
                </div>
              </>
            }
          >
            The terminal on your cloud computer, for your dev work. No laptop needed.
          </PhCard>
          <PhCard
            tag="Desktop"
            n="03"
            title="Full desktop"
            screen={
              <>
                <PhBar time="9:41" />
                <div className="ph-ttl">
                  <b>Desktop</b>
                  <span>cmx-you</span>
                </div>
                <div className="ph-dsk">
                  <div className="dk">
                    <div className="dk-mb">
                      <span>cmx-you</span>
                      <span>2:14</span>
                    </div>
                    <div className="dk-w dk-t">
                      <i className="dk-h">
                        <u />
                        <u />
                        <u />
                      </i>
                      <p>
                        <i>$</i> pnpm dev
                      </p>
                      <p className="ok">ready on :3000</p>
                      <p>
                        <i>$</i> claude
                      </p>
                    </div>
                    <div className="dk-w dk-b">
                      <i className="dk-h">
                        <u />
                        <u />
                        <u />
                        <em>localhost:3000</em>
                      </i>
                      <span className="r r1" />
                      <span className="r r2" />
                      <span className="r r3" />
                      <span className="tile" />
                      <span className="tile t2" />
                      <span className="dk-cta" />
                    </div>
                    <svg className="dk-ptr" width="10" height="14" viewBox="0 0 10 14" aria-hidden="true">
                      <path d="M1 1v11l3-3 2 4 2-1-2-4h4z" fill="#fff" stroke="#1C1917" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>
              </>
            }
          >
            The full desktop of your cloud computer, with the browser and every window.
          </PhCard>
          <PhCard
            tag="Lock screen"
            n="04"
            title="Notifications"
            screen={
              <>
                <PhBar time="2:14" />
                <div className="ph-lock">
                  <span className="dd">Tuesday</span>
                  <span className="tm">2:14</span>
                </div>
                <div className="ph-ntf">
                  <span className="ic">&gt;_</span>
                  <b>Agent needs you</b>
                  <span className="m">Run the migration on staging?</span>
                  <span className="ph-act">
                    <span>Not now</span>
                    <span className="pri">Approve</span>
                  </span>
                </div>
                <span className="ph-lb l" />
                <span className="ph-lb r" />
              </>
            }
          >
            When an agent needs you, you get a notification and can answer right there.
          </PhCard>
        </ul>
      </div>
    </section>
  );
}

/* cmx next to a laptop and a VPS, as a scorecard: what you need down the side (each with a 16px line icon, last in its
   row), the three options across. A cell is y (has it), n (falls short, struck) or p (only with effort); cmx's column is y all the way down */
type Got = 'y' | 'n' | 'p';
const OPTS = [
  { k: 'Option 1', t: 'Your laptop', s: 'In front of you', lb: 'Laptop' },
  { k: 'Option 2', t: 'A VPS', s: 'Stays on, but expensive', lb: 'VPS' },
  { k: 'cmx', t: 'CMX Cloud Machine', s: 'Always on, feels like your laptop', lb: 'cmx' },
];
const ROWS: [string, string, [Got, string], [Got, string], string, string][] = [
  ['On while you sleep', 'Lid closed, 24/7', ['n', 'No'], ['y', 'Yes'], 'Yes', 'M13 9.6A5.6 5.6 0 0 1 6.4 3a5.6 5.6 0 1 0 6.6 6.6Z'],
  ['Room for many agents', 'Plenty of CPU and memory', ['p', 'Shared with you'], ['n', 'Costly at this size'], 'Up to 16 cores, 64 GB', 'M5.5 4.5h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1ZM6.5 2v2.5M9.5 2v2.5M6.5 11.5V14M9.5 11.5V14M2 6.5h2.5M2 9.5h2.5M11.5 6.5H14M11.5 9.5H14'],
  ['Terminal feel', 'How typing feels', ['y', 'Instant'], ['n', 'Lags over SSH'], 'Instant', 'M3 3.5h10A1.5 1.5 0 0 1 14.5 5v6a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 11V5A1.5 1.5 0 0 1 3 3.5ZM4.5 6.5h.5M7.75 6.5h.5M11 6.5h.5M5 9.5h6'],
  ['Agent CLIs', 'Claude Code, Codex, Gemini', ['y', 'Smooth'], ['n', 'Flicker and stall'], 'Smooth', 'M3 2.5h10A1.5 1.5 0 0 1 14.5 4v8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 12V4A1.5 1.5 0 0 1 3 2.5ZM4.5 6.5 6.5 8l-2 1.5M8.5 10h3'],
  ['Clipboard, screenshots, files', 'Between you and the machine', ['y', 'Yes'], ['n', 'No'], 'Yes', 'M10.5 3h1A1.5 1.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 12.5v-8A1.5 1.5 0 0 1 4.5 3h1M6 1.75h4v2.5H6ZM5.75 8h4.5M5.75 10.75h3'],
  ['localhost in your browser', 'Open the dev server', ['y', 'Yes'], ['p', 'Tunnel it yourself'], 'Automatic', 'M3 2.5h10A1.5 1.5 0 0 1 14.5 4v8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 12V4A1.5 1.5 0 0 1 3 2.5ZM1.5 5.75h13M3.75 4.1h.5M5.75 4.1h.5'],
  ['A screen to look at', 'A browser, a GUI', ['y', 'Yes'], ['n', 'No'], 'Full desktop', 'M3 2.5h10A1.5 1.5 0 0 1 14.5 4v5.5A1.5 1.5 0 0 1 13 11H3a1.5 1.5 0 0 1-1.5-1.5V4A1.5 1.5 0 0 1 3 2.5ZM8 11v2.5M5.5 13.5h5'],
  ['Set up like your laptop', 'Your tools and dotfiles', ['y', 'It is your laptop'], ['p', 'From scratch'], 'One click', 'M4 3.5h8a1 1 0 0 1 1 1v6.5H3V4.5a1 1 0 0 1 1-1ZM1.5 13h13'],
  ['From your phone', 'Agents, terminal, desktop', ['n', 'No'], ['p', 'Barely'], 'Terminal and desktop', 'M5.5 1.5h5A1.5 1.5 0 0 1 12 3v10a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13V3a1.5 1.5 0 0 1 1.5-1.5ZM7 12h2'],
];
const GOT: Record<Got, [string, string]> = { y: ['Yes: ', 'M2 6.4l2.6 2.6L10 3.4'], n: ['Falls short: ', 'M2.5 2.5l7 7M9.5 2.5l-7 7'], p: ['With effort: ', 'M2.5 6h7'] };
const Score = ({ got: [g, text], lb, us }: { got: [Got, string]; lb: string; us?: boolean }) => (
  <td className={`${g}${us ? ' us' : ''}`}>
    <div className="cv">
      <span className="lb">{lb}</span>
      <span className="ic">
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
          <path d={GOT[g][1]} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" />
        </svg>
      </span>
      <span className="t">
        <span className="sr-only">{GOT[g][0]}</span>
        {text}
      </span>
    </div>
  </td>
);
export function Compare() {
  return (
    <section className="sec" id="compare" aria-labelledby="vs-title">
      <Marks />
      <div className="plate sec-head">
        <Kicker>Compare</Kicker>
        <h2 className="h2" id="vs-title">
          cmx vs. your laptop vs. a VPS.
        </h2>
      </div>
      <div className="plate-flush">
        <Marks flush />
        {/* roles kept explicit: on phones the rows become blocks, the column heads hide and each cell shows its own label */}
        <table className="sc" role="table">
          <colgroup>
            <col className="sc-k" />
            <col />
            <col />
            <col />
          </colgroup>
          <thead role="rowgroup">
            <tr role="row">
              <th scope="col" role="columnheader" className="sc-h">
                <span className="fnum">// What you need</span>
                <b>Nine things</b>
                <em>for agents and dev work</em>
              </th>
              {OPTS.map((o, i) => (
                <th scope="col" role="columnheader" className={`sc-h${i === 2 ? ' us' : ''}`} key={o.t}>
                  <span className="fnum">// {o.k}</span>
                  <b>{o.t}</b>
                  <em>{o.s}</em>
                </th>
              ))}
            </tr>
          </thead>
          <tbody role="rowgroup">
            {ROWS.map(([what, sub, lap, vps, us, ic]) => (
              <tr role="row" key={what}>
                <th scope="row" role="rowheader" className="sc-r">
                  <div className="sc-rw">
                    <span className="sc-ic">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d={ic} />
                      </svg>
                    </span>
                    <span>
                      <b>{what}</b>
                      {sub}
                    </span>
                  </div>
                </th>
                <Score got={lap} lb={OPTS[0].lb} />
                <Score got={vps} lb={OPTS[1].lb} />
                <Score got={['y', us]} lb={OPTS[2].lb} us />
              </tr>
            ))}
            <tr role="row" className="sc-f">
              <th scope="row" role="rowheader" className="sc-r">
                // In one line
              </th>
              {['Sleeps.', 'Painful.', 'Neither.'].map((t, i) => (
                <td className={i === 2 ? 'us' : undefined} key={t}>
                  <div className="cv">
                    <span className="lb">{OPTS[i].lb}</span>
                    {t}
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}

/* Questions, the VPS ones first */
const FAQ: [string, ReactNode][] = [
  ['How is this different from a VPS?', 'A VPS is a box you SSH into. cmx is a powerful computer that feels like your laptop: an instant terminal, your clipboard and localhost, a full desktop, your setup moved over in one click, and an iPhone app. It also costs about half as much as the same specs at the big clouds.'],
  ['Is it cheaper than a VPS?', 'Yes. The same CPU and memory costs about twice as much at the big clouds, and cmx has no usage fees.'],
  ['How powerful is it?', 'Up to 16 cores and 64 GB of memory. That’s enough to run several agents, builds, type checks, tests and dev servers at the same time.'],
  ['Is it really as fast as my laptop?', 'Typing in the terminal adds under 10 ms on top of your network, below what people can notice. The desktop streams to your laptop and you control it like your own monitor.'],
  ['What happens when I close my laptop?', 'Nothing stops. Your agents, builds and dev servers keep running on the cloud machine. Open your laptop, or your phone, and you’re back where they are.'],
  ['Do I have to set it up?', <>No. Magic Setup in the Mac app, or <code>cmx setup</code> in your terminal, brings your projects, agents, tools and sign-ins over. Nothing moves until you say so.</>],
  ['Which agents work?', 'Claude Code, Codex, Gemini CLI, Cursor Agent, OpenCode, Copilot CLI, Amp, Pi and more come preinstalled. Anything that runs on Linux works.'],
  ['Is my code safe?', 'Each machine is its own virtual machine, isolated from every other customer’s, and only you can reach it.'],
];
export function Faq() {
  return (
    <section className="sec" id="faq" aria-labelledby="faq-title">
      <Marks />
      <div className="plate sec-head">
        <Kicker>FAQ</Kicker>
        <h2 className="h2" id="faq-title">
          Common questions.
        </h2>
      </div>
      <div className="plate plate-fig">
        <div className="faq">
          {FAQ.map(([q, a], i) => (
            <details key={q} open={i === 0}>
              <summary>
                {q}
                <span className="fq-ic" aria-hidden="true" />
              </summary>
              <div className="fq-a">
                <p>{a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

const CHECK = (
  <svg className="pz2-ck" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M3.5 8.5L6.5 11.5L12.5 5" stroke="#1570EF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** A number whose digits roll to their place (the prototype's roller, in React). */
function Rolling({ n }: { n: number }) {
  const str = String(n);
  return (
    <span id="pz-digits" style={{ display: 'inline-flex' }}>
      {str.split('').map((d, k) => (
        <span className="rl" key={str.length - k}>
          <i style={{ transform: `translateY(${-Number(d) * 10}%)` }}>
            {'0123456789'.split('').map((x) => (
              <b key={x}>{x}</b>
            ))}
          </i>
        </span>
      ))}
    </span>
  );
}

/** A segmented choice: arrows move along it, like the prototype's. */
function Seg<T extends string>({ id, label, value, options, onPick }: { id: string; label: string; value: T; options: [T, ReactNode][]; onPick: (v: T) => void }) {
  return (
    <div className="pz2-f">
      <p className="pz2-l" id={`${id}-l`}>
        {label}
      </p>
      <div
        className="pz2-seg"
        role="radiogroup"
        aria-labelledby={`${id}-l`}
        id={id}
        onKeyDown={(e) => {
          const i = options.findIndex(([v]) => v === value);
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          if (step === undefined) return;
          e.preventDefault();
          const next = options[(i + step + options.length) % options.length][0];
          onPick(next);
          (e.currentTarget.querySelector(`[data-v="${next}"]`) as HTMLElement | null)?.focus();
        }}
      >
        {options.map(([v, text]) => (
          <button
            key={v}
            type="button"
            className="so"
            role="radio"
            data-v={v}
            aria-checked={v === value}
            tabIndex={v === value ? 0 : -1}
            onClick={() => onPick(v)}
            data-testid={`pz-${v}`}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
}

// the lowest monthly price for the same vCPU and memory at AWS Lightsail, DigitalOcean and Akamai (checked October 2026)
const ELSEWHERE: Record<number, number> = { 2: 44, 4: 84, 8: 164, 16: 384 };

// the hub's sizes and prices (GET /api/plans), fetched once for the page
let planList: Promise<PlanOption[] | null> | undefined;
function usePlans() {
  const [plans, setPlans] = useState<PlanOption[] | null>(null);
  useEffect(() => {
    planList ??= fetchPlans().then((r) => (r.ok ? r.data.plans : null));
    let live = true;
    void planList.then((p) => live && setPlans(p));
    return () => {
      live = false;
    };
  }, []);
  return plans;
}

/** "From $25 a month": the smallest size's price, once the hub has said it. */
export function FromPrice() {
  const plans = usePlans();
  const low = plans?.length ? Math.min(...plans.map((p) => p.monthly)) : 0;
  return low ? <>From {usd(low)} a month. </> : null;
}

/** Pricing: the machine you get for each size, drawn as you pick, at the hub's prices (GET /api/plans). */
export function Pricing({ signedIn }: { signedIn: boolean }) {
  const plans = usePlans();
  const [tier, setTier] = useState('standard-m');
  const [iv, setIv] = useState<Interval>('month');
  const art = useRef<SVGSVGElement>(null);
  const p = plans?.find((x) => x.id === tier);
  const m = p;
  useEffect(() => {
    if (m && art.current) PZ13.set(art.current, { cpu: m.vcpu, mem: m.memoryGB, sto: m.diskGB });
  }, [m]);
  const cents = p ? (iv === 'year' ? p.yearly : p.monthly) : 0;
  const per = iv === 'year' ? 'year' : 'month';
  const specs = m ? `${m.vcpu} vCPU · ${m.memoryGB} GB memory · ${m.diskGB} GB storage` : '';
  const elsewhere = m && ELSEWHERE[m.vcpu];
  const perMonth = p && iv === 'year' ? `$${(p.yearly / 1200).toFixed(2).replace(/\.00$/, '')} a month, billed yearly` : '';
  const href = `${signedIn ? '/plans' : '/signup'}?tier=${tier}&interval=${iv}`;
  return (
    <section className="sec" id="pricing" aria-labelledby="pricing-title">
      <span className="mk mk-l" aria-hidden="true"></span>
      <span className="mk mk-r" aria-hidden="true"></span>
      <div className="plate sec-head">
        <p className="kicker">
          <span data-dc="">// Pricing</span>{' '}
          <svg className="carets" width="36" height="5" aria-hidden="true">
            <use href="#carets" />
          </svg>
        </p>
        <h2 className="h2" id="pricing-title">
          About half the price of a cloud server.
        </h2>
        <p className="lead">Same specs, half the price of the big clouds. No usage fees.</p>
      </div>
      <div className="plate-flush">
        <span className="mk mk-l" style={{ left: '-4px' }} aria-hidden="true"></span>
        <span className="mk mk-r" style={{ right: '-4px' }} aria-hidden="true"></span>
        <div className="pz2">
          <figure className="pz2-art" aria-label={`Your machine: ${specs}`} id="pz2-art">
            <svg id="pzSvg" ref={art} aria-hidden="true" focusable="false"></svg>
          </figure>
          <div className="pz2-ctl">
            <Seg
              id="pz-size"
              label="Size"
              value={tier}
              onPick={setTier}
              options={(plans ?? []).map((x) => [x.id, x.name.replace('Standard ', '')] as [string, ReactNode])}
            />
            <Seg<Interval>
              id="pz-dur"
              label="Billing"
              value={iv}
              onPick={setIv}
              options={[
                ['month', 'Monthly'],
                ['year', <>Yearly <span className="pz-save">2 months free</span></>],
              ]}
            />
          </div>
          <div className="pz2-read">
            <div className="pz-price" aria-hidden="true">
              <span className="pz-amt nums">
                <span>$</span>
                <Rolling n={Math.round(cents / 100)} />
              </span>
              <span className="pz-per">/ {per}</span>
            </div>
            <p className="sr-only" aria-live="polite" id="pz-live">
              {p ? `${p.name}, ${cents / 100} dollars a ${per}` : ''}
            </p>
            <p className="pz-spec" id="pz-spec">
              {specs}
            </p>
            {perMonth && <p className="pz-spec pz-per-month">{perMonth}</p>}
            {elsewhere && <p className="pz-spec pz-else">Same specs elsewhere: from ${elsewhere} a month</p>}
          </div>
          <ul className="pz2-inc" aria-label="Included with every size">
            {['Always on, 24/7', 'Agents, Docker and Chrome preinstalled', 'Mac app, any browser and iPhone', 'Magic Setup moves your Mac in', 'Instant terminal, full desktop', 'No usage fees'].map((t) => (
              <li key={t}>
                {CHECK}
                <span>{t}</span>
              </li>
            ))}
          </ul>
          <div className="pz2-go">
            {p && !p.available ? (
              <Link to={href} className="btn btn-block" id="pz-go" data-testid="pz-go">
                {p.name} is full right now: get on the list
              </Link>
            ) : (
              <Link to={href} className="btn btn-primary btn-block" id="pz-go" data-testid="pz-go">
                <span id="pz-go-l">Get {p?.name ?? 'your cloud machine'}</span>
              </Link>
            )}
            <p className="pz-fine">
              Ready about two minutes after you pay. Change the size any time; it applies while your machine runs. Cancel any time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
